<div class="error-page">
  <img src="assets/images/error.svg" class="error-img">
  <h2>Strona nie istnieje!</h2>
</div>
